import GeolocationClass, * as GeolocationModule from './../node_modules/ol/Geolocation.js';

// Create a wrapper class
class Geolocation extends GeolocationClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in GeolocationModule) {
    if (key !== "default") {
        Geolocation[key] = GeolocationModule[key];
    }
}

export default Geolocation;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Geolocation.js';